import {
  Button,
  Chevron,
  Div,
  H3,
  Icon,
  Modal,
  P,
  Radio,
  Separator,
  TrashIconRed,
  centsToDollars,
  formatter,
  lightTheme,
} from '@vgrubs/components';
import { Dispatch, SetStateAction, useRef, useState } from 'react';
import { Collapsible } from '../../MenyStyled';
import {
  ModifierGroupItemV2Response,
  ModifierItemV2Response,
} from 'components/src/types/menu.types';

export const AddModifierGroupComponent = ({
  item,
  edit,
  setModifierGroups,
  modifierGroups,
  readOnly,
}: {
  item: ModifierGroupItemV2Response;
  edit?: boolean;
  setModifierGroups: Dispatch<SetStateAction<ModifierGroupItemV2Response[]>>;
  modifierGroups: ModifierGroupItemV2Response[];
  readOnly?: boolean;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [elementHeight] = useState(ref?.current?.clientHeight);

  const [expanded, setExpanded] = useState(false);
  const [areYouSureModal, setAreYouSureModal] = useState(false);

  function isSelected(item: ModifierGroupItemV2Response) {
    return modifierGroups?.some((location) => location.id === item.id);
  }

  const handleSelect = (newItem: ModifierGroupItemV2Response) => {
    const index = modifierGroups?.findIndex((item) => item === newItem);
    if (index === -1) {
      // Item doesn't exist, so add it
      setModifierGroups((prevIds) => [...prevIds, newItem]);
    } else {
      // Item exists, so remove it
      setModifierGroups((prevIds) =>
        prevIds.filter((item) => item !== newItem)
      );
    }
  };

  return (
    <Div $mb="8">
      <Div
        $box
        $p="16px 24px"
        $flex
        $alignCenter
        $between
        $mb="8"

        // $background={expanded && lightTheme.primary}
      >
        <Div $pointer $flex $alignCenter $gap="8px">
          {!edit && (
            <div onClick={() => handleSelect(item)}>
              <Radio checked={isSelected(item)} />
            </div>
          )}

          <P $bold $m="0" $left onClick={() => setExpanded((prev) => !prev)}>
            {item.name}
          </P>
        </Div>
        <Div $flex $alignCenter $gap="16px">
          {edit && !readOnly && (
            <Icon $pointer onClick={() => setAreYouSureModal(true)}>
              <TrashIconRed />
            </Icon>
          )}

          <Icon
            $pointer
            $rotate={expanded ? '360deg' : '180deg'}
            onClick={() => setExpanded((prev) => !prev)}
            // color={expanded ? lightTheme.white : lightTheme.darkGray}
          >
            <Chevron />
          </Icon>
        </Div>
      </Div>
      <Collapsible expanded={expanded} elementHeight={elementHeight}>
        <div ref={ref}>
          {item?.options?.map((item, i) => {
            return <ModifierComponent item={item} key={i} />;
          })}
          {item?.options?.length === 0 ? (
            <P $m="0" $center>
              No modifiers
            </P>
          ) : null}
        </div>
      </Collapsible>
      <Modal
        isOpen={areYouSureModal}
        closeModal={() => {
          setAreYouSureModal(false);
        }}
        logo={false}
        zIndex={110}
        overlayBorderRadius={30}
      >
        <H3 $mb="24" $color={lightTheme.primary}>
          Are you sure
        </H3>
        <P $mb="40">Are you sure you want to remove this modifier group?</P>

        <Div $flex $gap="16px">
          <Button
            onClick={() => {
              handleSelect(item);
              setAreYouSureModal(false);
            }}
            $w="100%"
            $selected
          >
            Remove
          </Button>
          <Button
            $selected
            $gray
            $w="100%"
            onClick={() => setAreYouSureModal(false)}
          >
            Cancel
          </Button>
        </Div>
      </Modal>
    </Div>
  );
};

export const ModifierComponent = ({
  item,
}: {
  item: ModifierItemV2Response;
}) => {
  return (
    <>
      <Separator />
      <Div $p="16px 20px" $flex $between $alignCenter>
        <P $m="0">{item.name}</P>
        <P $m="0">{formatter.format(centsToDollars(item.price))}</P>
      </Div>
    </>
  );
};
